export const chatErrorHandler = (url, error) => {
  if (url !== "/v2/chats") return;
  if (!error.response) return;
  const { code, message } = error?.response?.data;
  if (code === 50) {
    error.message = message;
  }
};
